import { convertListToObjectBy, emptyArr } from '@beef/utils';
import { getAddressData, getRegion } from '@fttb/common/store';
import { createSelector } from '@reduxjs/toolkit';
import { PAGE_TYPE_EVENT_NAMES, PAGE_TYPE_EVENTS, PAGE_TYPES } from "./constants";
import { getPageTypeByUrl } from "../../utils";
import { getIsPresetUpFlag } from "../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { FttbBlocks } from "../../blocks/constants";
import { getContentData, getIsOnTariffClick } from "../selectors";
import { getActiveCtn, getPageType, getUserType } from "../shared/selectors";
var getBlocksListUnordered = function getBlocksListUnordered(state) {
  var _getContentData;
  return ((_getContentData = getContentData(state)) === null || _getContentData === void 0 ? void 0 : _getContentData.blocks) || emptyArr;
};
export var getBlocksList = createSelector(getBlocksListUnordered, function (blocks) {
  return blocks.slice().sort(function (a, b) {
    return a.positionOrder - b.positionOrder;
  });
});
var getBlocksDict = createSelector(getBlocksList, convertListToObjectBy('alias'));
export var getBlocksAliasList = createSelector(getBlocksList, function (list) {
  return list.map(function (item) {
    return item.alias;
  });
});

/**
 * Separate blocks
 */
export var getHeadingBlock = function getHeadingBlock(state) {
  return getBlocksDict(state)[FttbBlocks.HEADING];
};
export var getInfoCardsBlock = function getInfoCardsBlock(state) {
  return getBlocksDict(state)[FttbBlocks.INFO_CARDS];
};
export var getAdvantagesBlock = function getAdvantagesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADVANTAGES_CARDS];
};
export var getAboutConnectionBlock = function getAboutConnectionBlock(state) {
  return getBlocksDict(state)[FttbBlocks.CONNECTION_CARDS];
};
export var getCheckAddressBlock = function getCheckAddressBlock(state) {
  return getBlocksDict(state)[FttbBlocks.CHECK_ADDRESS];
};
export var getTariffsBlock = function getTariffsBlock(state) {
  return getBlocksDict(state)[FttbBlocks.TARIFFS];
};
export var getAdditionalServicesBlock = function getAdditionalServicesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADDITIONAL_SERVICES];
};
export var getAdditionalInfoBlock = function getAdditionalInfoBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADDITIONAL_INFO];
};
export var getDevicesBlock = function getDevicesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.DEVICES];
};
export var getQuizBlock = function getQuizBlock(state) {
  return getBlocksDict(state)[FttbBlocks.QUIZ];
};
export var getLeavePhoneBlock = function getLeavePhoneBlock(state) {
  return getBlocksDict(state)[FttbBlocks.LEAVE_PHONE];
};
export var getFAQBlock = function getFAQBlock(state) {
  return getBlocksDict(state)[FttbBlocks.FAQ];
};
export var getBannerBlock = function getBannerBlock(state) {
  return getBlocksDict(state)[FttbBlocks.BANNER];
};
export var getHomeTariffBannerBlock = function getHomeTariffBannerBlock(state) {
  return getBlocksDict(state)[FttbBlocks.HOME_TARIFFS_BANNER];
};
export var getNewsBlock = function getNewsBlock(state) {
  return getBlocksDict(state)[FttbBlocks.NEWS];
};
export var getAddressBlock = function getAddressBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADDRESS_VERIFICATION];
};
export var getArticlesBlock = function getArticlesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ARTICLES];
};
export var activeCtn = function activeCtn(state) {
  return getActiveCtn(state);
};
export var userType = function userType(state) {
  return getUserType(state);
};

/**
 * Selectors for analytics
 */
export var getAnalyticEventType = createSelector([getPageType, getPageTypeByUrl], function (pageType, pageTypeByUrl) {
  return PAGE_TYPE_EVENT_NAMES[pageType] || pageTypeByUrl;
});
export var getAnalyticsEventType = createSelector([getPageType], function (pageType) {
  return PAGE_TYPE_EVENTS[pageType] || getPageTypeByUrl;
});
export var isPageTypeFmc = createSelector([getPageType], function (pageType) {
  return pageType === PAGE_TYPES.fmc;
});
export var getFullAddress = createSelector([getRegion, getAddressData], function (region, _ref) {
  var house = _ref.house,
    street = _ref.street;
  return "".concat(region === null || region === void 0 ? void 0 : region.label, ", ").concat(street.label, ", ").concat(house.label);
});
export var getIsConvergent = createSelector([getIsOnTariffClick, getIsPresetUpFlag, isPageTypeFmc], function (isOnTariffClick, isPresetUpFlag, isPageTypeFmcFlag) {
  return isOnTariffClick ? isPresetUpFlag : isPageTypeFmcFlag;
});